module.exports = __webpack_public_path__ + "img/p31.5704b701.jpg";